/**
 * Copyright (c) 2024 ForgeRock. All rights reserved.
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */

// eslint-disable-next-line import/prefer-default-export
export const JAVASCRIPT_SDK_TIMEOUT = 60 * 1000;
